import React from 'react';
import './SendPdfButton.css';

const SendPdfButton = ({ onClick, isButtonEnabled, isLoading }) => {
  return (
    <button className="send-pdf-btn" onClick={onClick} disabled={!isButtonEnabled || isLoading}>
      Wyślij 
    </button>
  );
};

export default SendPdfButton;
